'use strict';

class ThankYou extends BaseComponent {
	constructor(element, state) {
		//init BaseComponent
		super(element, state);

		//set template id
		this._view = $('#thankyou_ThankYou').html();

		//set template props
		this._props = {
			copy01: _t('thankyou_copy01'),
			copy02: _t('thankyou_copy02'),
			copy03: _t('thankyou_copy03'),
			copy04: _t('thankyou_copy04'),
			btn_digitorial: _t('thankyou_btn_digitorial'),
			btn_digitorial_url: _t('thankyou_btn_digitorial_url'),
			copy_newsletter: _t('thankyou_copy_newsletter'),
			btn_newsletter: _t('thankyou_btn_newsletter'),
			btn_newsletter_url: _t('thankyou_btn_newsletter_url'),
		};


		return this
	}

	init() {
		this.$blueBox = $('.blue-box', this.$el);
		this.$imgDevices = $('.img-devices', this.$el);
		this.$btnToDigitorial = $('.btn-to-digitorial', this.$el);
		this.$btnNewsletter = $('.btn-newsletter', this.$el);

		//fade in animation
		this.fadeHideElement(this.$blueBox)
			.fadeHideElement(this.$imgDevices)
			.fadeHideElement(this.$btnToDigitorial)
			.fadeHideElement(this.$btnNewsletter);

		this.timeline = new TimelineLite();
		this.timeline.call(this.fadeInElement, [this.$blueBox], this, "+=0.3");
		this.timeline.call(this.fadeInElement, [this.$imgDevices], this, "+=0.5");
		this.timeline.call(this.fadeInElement, [this.$btnToDigitorial], this, "+=0.5");
		this.timeline.call(this.fadeInElement, [this.$btnNewsletter], this, "+=0.1");
		this.timeline.play();

		return this
	}


}

if(!_.isObjectLike(site)) var site = {components:{}};
site.components.ThankYou = ThankYou;
